import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";

import { MarketplaceItemModel } from "../../models/marketplace-item.model";
import { SearchTabConfigModel } from "../../models/search-tab-config.model";
import { PdfDropdownManager } from "../../../../../shared-library/types/pdf-dropdown-manager";
import { BehaviorSubject, fromEvent } from "rxjs";
import { map } from "rxjs/operators";

declare function externalGetPdfDropdown(): InstanceType<PdfDropdownManager> | undefined;

@Component({
    selector: "pcg-ng-marketplace-item-details-card",
    template: require('./marketplace-item-details-card.component.html')
})
export class MarketplaceItemDetailsCardComponent implements OnInit {
    @Input() public itemToDisplay: MarketplaceItemModel;
    @Input() public searchTabConfig: SearchTabConfigModel;

    protected pdfDropdown = externalGetPdfDropdown();
    protected isInBooklet$: BehaviorSubject<{ is: boolean }>;

    public ngOnInit(): void {
        this.isInBooklet$ = new BehaviorSubject<{is: boolean}>({is: this.isInBooklet});

        fromEvent(window, "sc-my-favourites__update").pipe(
            map(e => this.isInBooklet)
        ).subscribe(is => this.isInBooklet$.next({ is: is }));
    }

    public addToBooklet(e: Event): void {
        e.preventDefault();

        if (!!this.pdfDropdown) {
            if (!this.isInBooklet) {
                this.pdfDropdown.addLink(this.itemToDisplay.name, this.getDetailsPageUrl(false));
            }
        }

        this.isInBooklet$.next({is: this.isInBooklet});
    }

    public removeFromBooklet(e: Event): void {
        e.preventDefault();

        if (!!this.pdfDropdown) {
            const items = this.pdfDropdown.getItems();
            const itemToDelete = items.find(i => i.href === this.getDetailsPageUrl(false));
            if (!!itemToDelete) {
                this.pdfDropdown.removeLink(itemToDelete.key);
            }
        }

        this.isInBooklet$.next({is: this.isInBooklet});
    }

    public getDetailsPageUrl(includeReturnUrl: boolean = true): string {
        return `${this.searchTabConfig.viewPageUrl}?supplierId=${this.itemToDisplay.supplierId}&bcgId=${this.itemToDisplay.catalogueId}&productId=${this.itemToDisplay.id}` + (includeReturnUrl ? `&returnUrl=${encodeURIComponent(window.location.href)}` : "");
    }

    public get isInBooklet(): boolean {
        const items = this.pdfDropdown?.getItems() ?? [];
        return !!items.find(i => i.href === this.getDetailsPageUrl(false));
    }
}
